/* eslint-disable jsx-a11y/accessible-emoji */
import React, { Component } from 'react';
import Styles from './Styles'
import { Form, Field } from 'react-final-form'

export default class SampleForm extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        return (
            <Styles>
                <h1>Contact Details</h1>
                <Form
                    onSubmit={this.props.function}
                    initialValues={""}
                    render={({ handleSubmit, form, submitting, pristine, values }) => (
                        <form onSubmit={handleSubmit}>
                            <div>
                                <label>First Name</label>
                                <Field
                                    name="First Name"
                                    component="input"
                                    type="text"
                                    placeholder="First Name"
                                />
                            </div>
                            <div>
                                <label>Last Name</label>
                                <Field
                                    name="Last Name"
                                    component="input"
                                    type="text"
                                    placeholder="Last Name"
                                />
                            </div>
                            <div>
                                <label>Company</label>
                                <Field
                                    name="Company Name"
                                    component="input"
                                    type="text"
                                    placeholder="Company Name"
                                />
                            </div>
                            <div>
                                <label>Mobile No</label>
                                <Field
                                    name="Phone Number"
                                    component="input"
                                    type="text"
                                    placeholder="Phone Number"
                                />
                            </div>
                            <div>
                                <label>Email</label>
                                <Field
                                    name="Email Address"
                                    component="input"
                                    type="text"
                                    placeholder="Email Address"
                                />
                            </div>
                            <div>
                                <label>Industry Sector</label>
                                <Field name="Industry" component="select">
                                    <option />
                                    <option value="Solar">Solar Panels</option>
                                    <option value="Manufacturing">Manufacturing</option>
                                    <option value="Automobiles">Automobiles</option>
                                    <option value="Semiconductors">Semiconductors</option>
                                </Field>
                            </div>
                            <div className="buttons">
                                <button type="submit" disabled={submitting || pristine}>
                                    Submit
                                </button>
                            </div>
                        </form>
                    )}
                />
            </Styles>
        )
    }
}